export const meta: BlockMeta = {
  title: "Upcoming Events",
  description: "A preview of upcoming events, if there are any",
  category: "embed",
  icon: "calendar",
  keywords: ["events", "latest"],
  conditions: {
    postTypes: ["page", "post"],
  },
  tags: ["root"],
}

import { Stub } from "@components/atoms/Stub"
import { EventCard } from "@components/cards/EventCard"
import { defineBlock, EditableText } from "eddev/blocks"

export default defineBlock("feeds/upcoming-events", (props) => {
  if (props.events?.nodes.length === 0) {
    if (env.admin) {
      return <Stub>Upcoming events will feature here, however there are currently none to show!</Stub>
    }
    return null
  }
  return (
    <div className="grid-auto auto-cols-9 mt-7">
      <EditableText
        as="p"
        store="heading"
        placeholder="Enter an optional label"
        defaultValue="Coming up:"
        className="type-body-m-roman col-span-full my-4"
      />
      {props.events?.nodes.map((event) => (
        <div key={event.uri} className="col-span-12 sm:col-span-3 md:col-span-3 lg:col-span-2">
          <EventCard {...event} />
        </div>
      ))}
    </div>
  )
})
